export const intervalTime = 900000; // 15 minutes
